module.exports = __webpack_public_path__ + "img/w3_user_white.c29901b7.png";